const CIDKEY = 'cid_key';

function setCid(cid) {
  return localStorage.setItem(CIDKEY, cid);
}

function getCid() {
  return localStorage.getItem(CIDKEY);
}

function removeCid() {
  return localStorage.removeItem(CIDKEY);
}

export {
  setCid,
  getCid,
  removeCid
};
